import React from "react";
import { RecoilRoot } from "recoil";
import Helmet from "react-helmet";
import { GlobalStyle } from "@myrealtrip/design-system";
import { checkWebView } from "@func";
import { DetermineMobileProiver } from "@modules";

import "./src/styles/style.scss";

export const wrapRootElement = ({ element }) => {
  const isWebView = checkWebView();

  // 웹로그 웹뷰 모드 설정
  if (isWebView) {
    window.MRT_WEBLOG_EXEC_MODE = "WEBVIEW";
  }

  return (
    <React.Fragment>
      <Helmet>
        <script async src={process.env.GATSBY_WEBLOG_URL}></script>
      </Helmet>
      <GlobalStyle />
      <RecoilRoot>
        <DetermineMobileProiver>{element}</DetermineMobileProiver>
      </RecoilRoot>
    </React.Fragment>
  );
};
